<template>
    <VJoyProductTour
        ref="productTourRef"
        position="left"
        data-testid="client-browse-profiles-product-tour"
        :spotlight-selector="spotlightTarget"
        :max-width="400"
        :close-button="false"
    >
        <template #product-tour-content>
            {{ t('search.browse.profiles.onboarding.content') }}
        </template>
        <template #product-tour-next>
            <VJoyButton
                :label="t('search.browse.profiles.onboarding.cta')"
                size="small"
                variant="main"
                data-testid="client-browse-profiles-product-tour-cta"
                @click="close"
            />
        </template>
    </VJoyProductTour>
</template>

<script setup lang="ts">
    import {computed, onMounted, useTemplateRef} from 'vue';
    import {useTranslation, useRoute, useLogger} from '#imports';
    import {VJoyButton, VJoyProductTour} from '@maltjoy/core-vue';
    import {useClientOnboarding} from './useClientOnboarding';

    const {t} = useTranslation();
    const {acknowledgeBrowseProfilesOnboarding, getBrowseProfilesOnboarding} = useClientOnboarding();

    const productTourRef = useTemplateRef('productTourRef');
    const route = useRoute();
    const logger = useLogger();

    const spotlightTarget = computed(() => (route.hash && getElement(route.hash) ? route.hash : "[data-client-browse-profiles-product-tour='1']"));

    function getElement(selector: string) {
        const $element = document.querySelector(selector);
        if (!$element) {
            logger.warn(`Selector ${selector} invalid`);
            return;
        }
        return $element;
    }

    onMounted(async () => {
        const shouldDisplayOnboarding = await getBrowseProfilesOnboarding();
        if (shouldDisplayOnboarding) {
            productTourRef.value?.show();
            await acknowledgeBrowseProfilesOnboarding();
        }
    });

    function close() {
        productTourRef.value?.hide();
    }
</script>
